import _ from 'lodash';

export function formatValue(value: number, decimals = 0, prefix?: string, suffix?: string) {
    const val = value.toLocaleString(undefined, {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
    });
    return `${prefix || ''}${val}${suffix || ''}`;
}

export function roundNear(value: number) {
    const length = value.toFixed().length;
    const multiplier = Math.pow(10, Math.max(length - 2, 0));
    return Math.round(value / multiplier) * multiplier;
}

export function transformValue(value?: number, multiplier?: number, decimals?: number, restore?: boolean) {
    const m =  multiplier || 1;
    const val = _.round((value || 0) * m, decimals);
    return restore ? (val / m) : val;
}